export const EXSBINVOICEPOSITION_SHOW_RESET = 'EXSBINVOICEPOSITION_SHOW_RESET'
export const EXSBINVOICEPOSITION_SHOW_SET_ERROR = 'EXSBINVOICEPOSITION_SHOW_SET_ERROR'
export const EXSBINVOICEPOSITION_SHOW_SET_RETRIEVED = 'EXSBINVOICEPOSITION_SHOW_SET_RETRIEVED'
export const EXSBINVOICEPOSITION_SHOW_TOGGLE_LOADING = 'EXSBINVOICEPOSITION_SHOW_TOGGLE_LOADING'
